import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/LandingPageNew/Navbar";

import API from "../utils/api";
const HowRemoveStep2 = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedReviews, setSelectedReviews] = useState([]);
  const [pricePerDeletion, setPricePerDeletion] = useState(129.0);
  const [activeTier, setActiveTier] = useState(0);
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [selectedStars, setSelectedStars] = useState([]); // e.g. [1, 2, 3]
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const location = useLocation();
  // selected place (after user clicks one)
  const [business, setBusiness] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [starCount, setStarCount] = useState({});
  const hasSidebar = currentStep === 2 || currentStep === 3;
  const [places, setPlaces] = useState(location.state?.places || []);
  const [formData, setFormData] = useState({
    salutation: "",
    firstName: "",
    surname: "",
    email: "",
    phone: "",
    firma: "",
    street: "",
    plz: "",
    location: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Build selected review objects (author + date + rating + text)
      const selectedReviewObjects = selectedReviews.map((idx) => {
        const r = reviews[idx];
        return {
          review_id: r?.review_id || r?.id || null,
          authorName: getAuthorName(r),
          date: getFormattedDate(r),
          rating: r?.rating || 0,
          text: getReviewText(r),
        };
      });

      const payload = {
        formName: "Bewertungen – Schritt 3",
        formData,
        business: {
          name: business?.name, // keep as object (name.text exists)
          rating: business?.rating,
          totalReviews: business?.totalReviews,
          place_id: business?.place_id || business?.placeId || business?.id,
        },
        selectedReviews: selectedReviewObjects,
        pricing: {
          pricePerDeletion,
          total: selectedReviewObjects.length * pricePerDeletion,
        },
      };

      const response = await API.post("/contact4", payload);

      alert("Formular wurde erfolgreich übermittelt 🎉", { duration: 10000 });
      console.log(response.data);

      // Reset
      setFormData({
        salutation: "",
        firstName: "",
        surname: "",
        email: "",
        phone: "",
        firma: "",
        street: "",
        plz: "",
        location: "",
      });
      setSelectedReviews([]);
      setSelectedStars([]);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.", {
        duration: 10000,
      });
    }
  };

  useEffect(() => {
    if (location.state?.places) {
      setPlaces(location.state.places);
    }
  }, [location.state]);
  useEffect(() => {
    // scroll page to top when step changes
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [currentStep]);

  const handleStarSelect = (star) => {
    setSelectedStars((prevStars) => {
      const isSelected = prevStars.includes(star);
      const updatedStars = isSelected
        ? prevStars.filter((s) => s !== star)
        : [...prevStars, star];

      // Get indexes of reviews that match this star
      const matchingIndexes = reviews
        .map((r, idx) => (r.rating === star ? idx : null))
        .filter((idx) => idx !== null);

      setSelectedReviews((prevSelected) => {
        let updatedSelected;

        if (isSelected) {
          // REMOVE all reviews of this star
          updatedSelected = prevSelected.filter(
            (idx) => !matchingIndexes.includes(idx)
          );
        } else {
          // ADD all reviews of this star
          updatedSelected = Array.from(
            new Set([...prevSelected, ...matchingIndexes])
          );
        }

        updatePricing(updatedSelected.length);
        return updatedSelected;
      });

      return updatedStars;
    });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    console.log("places", places);
  }, []);
  const navigate = useNavigate();

  useEffect(() => {
    // push initial step
    window.history.replaceState({ step: 1 }, "", "");

    const handlePopState = (event) => {
      if (event.state?.step) {
        setCurrentStep(event.state.step);
      } else {
        // no step state → leave page
        navigate(-1);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  const goToStep = (step) => {
    setCurrentStep(step);
    window.history.pushState({ step }, "", "");
  };

  // const [name, setName] = useState(companyData?.name?.text);
  const nextStep = () => {
    setMobileSidebarOpen(false);
    goToStep(3);
  };
  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [currentStep]);

  const getReviewText = (review) => {
    return (
      review?.snippet ||
      review?.extracted_snippet?.original ||
      "Kein Text verfügbar"
    );
  };

  const getAuthorName = (review) => {
    return review?.user?.name || "Unbekannter Nutzer";
  };

  const getFormattedDate = (review) => {
    if (review?.iso_date) {
      return new Date(review.iso_date).toLocaleDateString("de-DE", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }
    return review?.date || "Unbekanntes Datum";
  };

  const updatePricing = (count) => {
    let perDeletion = 129.0;
    let tier = 0;
    if (count > 10) {
      perDeletion = 79.0;
      tier = 2;
    } else if (count > 5) {
      perDeletion = 89.0;
      tier = 1;
    }
    setPricePerDeletion(perDeletion);
    setActiveTier(tier);
  };
  const handleReviewSelect = (idx) => {
    setSelectedReviews((prev) => {
      let updatedSelection = prev.includes(idx)
        ? prev.filter((i) => i !== idx)
        : [...prev, idx];

      updatePricing(updatedSelection.length); // Update price based on current selection
      return updatedSelection;
    });
  };
  const calculateNewRating = () => {
    if (!business || !reviews) return 0;

    const totalRatingSum = business.rating * business.totalReviews;

    // Sum of selected reviews' ratings (only from the 5 recent reviews)
    const selectedSum = selectedReviews.reduce(
      (acc, idx) => acc + (reviews[idx]?.rating || 0),
      0
    );

    const newTotalReviews = business.totalReviews - selectedReviews.length;
    if (newTotalReviews <= 0) return 0;

    const newAverage = (totalRatingSum - selectedSum) / newTotalReviews;
    return newAverage.toFixed(1);
  };

  const handlePlaceSelect = async (place) => {
    try {
      setBusiness(place);
      goToStep(2);
      setReviewsLoading(true);
      setReviews([]);
      setStarCount({});
      setSelectedReviews([]);

      const placeId = place.place_id || place.placeId || place.id;
      if (!placeId) throw new Error("Place ID not found");

      const res = await API.get(`/google/place-details/google-maps-reviews2`, {
        params: {
          place_id: placeId,
        
        },
      });

      if (!res.data.success) throw new Error(res.data.message);
      const apiReviews = res.data.data.reviews || [];
      setReviews(apiReviews);

      const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      apiReviews.forEach((r) => {
        if (counts[r.rating] !== undefined) {
          counts[r.rating]++;
        }
      });

      setStarCount(counts);
    } catch (error) {
      console.error("Review fetch error:", error);
    } finally {
      setReviewsLoading(false);
    }
  };

  const handleProceed = () => {
    goToStep(3);
  };
  const PRICING_TIERS = [
    {
      min: 0,
      max: 5,
      price: 129,
      nextSave: 200,
    },
    {
      min: 6,
      max: 10,
      price: 89,
      nextSave: 50,
    },
    {
      min: 11,
      max: Infinity,
      price: 79,
      nextSave: 0,
    },
  ];
  const selectedCount = selectedReviews.length;

  const currentTierData = PRICING_TIERS[activeTier];

  // Remaining reviews for next tier
  const reviewsLeftForNextTier =
    activeTier < PRICING_TIERS.length - 1
      ? PRICING_TIERS[activeTier].max - selectedCount
      : 0;

  // Save amount for next tier
  const saveAmount = currentTierData.nextSave;
  const getProgressPercentage = () => {
    if (activeTier === 0) {
      return Math.min((selectedCount / 5) * 100, 100);
    }

    if (activeTier === 1) {
      return Math.min(((selectedCount - 5) / 5) * 100, 100);
    }

    return 100; // Tier 2 is always full
  };

  return (
    <>
      <Navbar />
      <section className="relative bg-cover bg-no-repeat font-sans py-4 md:py-8 px-4">
        {/* TOP SECTION: Heading + Subtitle */}
        <div className="flex justify-center mt-14">
          <div className="relative w-full max-w-[1300px] mx-auto p-2 lg:p-10 flex flex-col gap-8">
            <div className="flex w-full gap-10">
              <div
                className={`flex flex-col gap-8 transition-all duration-300 w-full md:${
                  hasSidebar ? "w-full md:w-[72%]" : "w-full"
                }`}
              >
                {/* Company Header */}
                <div className="flex  flex-col gap-3 mb-10 mt-10 items-center text-center">
                  <h2 className="h2-mb h2-md h2-lg h2-2xl">
                    Unfaire Bewertung(en)? <br />
                    <span className="text-[#0b2b40]">
                      Wie Sie die Löschung einleiten:
                    </span>
                  </h2>
                  <p className="text-gray-500 text-sm md:text-lg w-11/12 md:w-11/12 mt-2 text-center">
                    Unser Bewertungsmanager gibt Ihnen die Kontrolle über Ihren
                    Ruf zurück - ganz risikofrei, denn Sie zahlen nur bei
                    erfolgreicher Löschung.
                  </p>
                </div>

                {/* STEPS */}
                <div className="hidden lg:flex justify-center mt-2 gap-10 items-center">
                  <StepCircle
                    active={currentStep === 1}
                    number="1"
                    text="Firmenname eingeben"
                  />
                  <StepLine active />
                  <StepCircle
                    active={currentStep === 2}
                    number="2"
                    text="Negative Bewertung auswählen"
                  />
                  <StepLine active={currentStep > 2} />
                  <StepCircle
                    active={currentStep === 3}
                    number="3"
                    text="Vorgang starten"
                  />
                </div>

                <div className="lg:hidden flex justify-center mt-2 gap-6">
                  <StepCircle
                    active={currentStep === 1}
                    number="1"
                    text="Firmenname eingeben"
                  />
                  <StepLine active />
                  <StepCircle
                    active={currentStep === 2}
                    number="2"
                    text="Negative Bewertung auswählen"
                  />
                  <StepLine active={currentStep > 2} />
                  <StepCircle
                    active={currentStep === 3}
                    number="3"
                    text="Vorgang starten"
                  />
                </div>
                {currentStep === 1 && (
                  <div className="w-full mx-auto mt-10">
                    <div className="border rounded-2xl p-6 bg-white">
                      {/* Header */}
                      <div className="flex justify-between items-center pb-4 border-b">
                        <h2 className="text-xl font-semibold">
                          Suchergebnisse
                        </h2>
                        <span className="text-sm text-gray-500">
                          {places.length} Ergebnis{places.length !== 1 && "se"}{" "}
                          gefunden
                        </span>
                      </div>

                      {/* Results */}
                      <div className="mt-4 space-y-4">
                        {places.map((place) => (
                          <div
                            key={place.id}
                            className="flex flex-col md:flex-row justify-between items-left md:items-center p-4 rounded-xl hover:bg-gray-50 transition"
                          >
                            {/* Left: Name & Address */}
                            <div className="flex flex-col gap-1">
                              <h3 className="font-semibold text-gray-900">
                                {place?.name?.text}
                              </h3>
                              <p className="text-sm text-gray-500">
                                {place.address}
                              </p>
                            </div>

                            {/* Right: Rating + Button */}
                            <div className="flex flex-col md:flex-row items-left md:items-center gap-6">
                              {/* Rating */}
                              <div className="flex items-center gap-2">
                                <span className="font-medium text-gray-900">
                                  {place.rating?.toFixed(1)}
                                </span>
                                <span className="text-yellow-400 text-lg">
                                  {"★".repeat(Math.round(place.rating || 0))}
                                  {"☆".repeat(
                                    5 - Math.round(place.rating || 0)
                                  )}
                                </span>
                                <span>({place.totalReviews})</span>
                              </div>

                              {/* Select Button */}
                              <button
                                onClick={() => handlePlaceSelect(place)}
                                className="bg-[#0b2b40] text-white px-6 py-2 rounded-full text-sm font-medium hover:opacity-90 transition"
                              >
                                Auswählen
                              </button>
                              <hr />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {currentStep === 2 && (
                  <div>
                    <div className="flex flex-col md:flex-row gap-8">
                      <div className="flex-1 items-start gap-6">
                        <img
                          src={business?.photoUrl}
                          alt="Company"
                          className="w-full rounded-xl object-cover mb-2"
                          style={{ height: "150px" }}
                        />
                        <div className="flex flex-col">
                          <h2 className="text-2xl font-semibold leading-tight flex flex-wrap items-center gap-2">
                            <span className="text-gray-800">
                              {business?.name?.text}
                            </span>
                            <span className="bg-yellow-100 text-yellow-800 text-sm font-medium px-2 py-1 rounded-full flex items-center mt-2 gap-1">
                              <svg
                                className="w-4 h-4"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.955a1 1 0 00.95.69h4.15c.969 0 1.371 1.24.588 1.81l-3.36 2.44a1 1 0 00-.364 1.118l1.287 3.955c.3.921-.755 1.688-1.54 1.118l-3.36-2.44a1 1 0 00-1.176 0l-3.36 2.44c-.784.57-1.838-.197-1.539-1.118l1.286-3.955a1 1 0 00-.364-1.118L2.025 9.382c-.783-.57-.38-1.81.588-1.81h4.15a1 1 0 00.95-.69l1.286-3.955z" />
                              </svg>
                              {business?.totalReviews} Bewertung(en)
                            </span>
                          </h2>

                          <div className="flex items-center gap-2 mt-2">
                            <span className="text-gray-800 text-xl font-semibold">
                              {business?.rating?.toFixed(1)}
                            </span>
                            <span className="text-yellow-500 text-4xl">
                              {"★".repeat(Math.round(business?.rating || 0))}
                              {"☆".repeat(
                                5 - Math.round(business?.rating || 0)
                              )}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="flex-1">
                        <h3 className="font-semibold mb-3 text-lg">
                          Jetzt Bewertungen auswählen
                        </h3>
                        <div className="flex flex-col gap-3">
                          {[1, 2, 3].map((star) => (
                            <label
                              key={star}
                              className="flex items-center justify-between cursor-pointer"
                            >
                              <div className="flex items-center gap-2">
                                <input
                                  type="checkbox"
                                  className="h-4 w-4"
                                  checked={selectedStars.includes(star)}
                                  onChange={() => handleStarSelect(star)}
                                />
                                <span>
                                  {star} Star ({starCount[star] || 0})
                                </span>
                              </div>
                              <span className="text-yellow-500 text-2xl">
                                {"★".repeat(star) + "☆".repeat(5 - star)}
                              </span>
                            </label>
                          ))}
                        </div>
                        <div className="mt-6 p-2 rounded-2xl bg-gradient-to-r from-green-100 via-green-50 to-white shadow-2xl flex flex-col items-center text-center">
                          <h2 className="text-sm md:text-sm font-semibold leading-tight text-gray-800 mb-4">
                            Nach Optimierung mögliches Top-Rating: <br />
                            <span className="ml-1 font-boldtext-[#8ec700] text-xl==lg md:text-2xl bg-gradient-to-r from-green-500 to-green-700 text-transparent bg-clip-text drop-shadow-md">
                              Von: {business?.rating?.toFixed(1)} → auf:{" "}
                              {calculateNewRating()}
                            </span>
                            {Array.from({ length: 5 }).map((_, index) => {
                              const newRating = calculateNewRating();
                              return (
                                <span
                                  key={index}
                                  className={`text-xl ml-2 ${
                                    index < Math.round(newRating)
                                      ? "text-yellow-500"
                                      : "text-gray-300"
                                  }`}
                                >
                                  ★
                                </span>
                              );
                            })}
                          </h2>
                        </div>
                      </div>
                    </div>

                    <hr />

                    {/* Reviews Grid */}

                    <div className="relative mt-6 min-h-[200px]">
                      {/* 🔄 LOADER */}
                      {reviewsLoading && (
                        <div className="absolute inset-0 flex items-center justify-center bg-white/70 z-10 rounded-xl">
                          <div className="flex flex-col items-center gap-3">
                            <div className="animate-spin rounded-full h-10 w-10 border-4 border-[#0b2b40] border-t-transparent"></div>
                            <p className="text-sm text-gray-600">
                              Bewertungen werden geladen...
                            </p>
                          </div>
                        </div>
                      )}

                      {/* 🧾 REVIEWS GRID */}
                      {!reviewsLoading && reviews.length > 0 && (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                          {reviews.map((review, idx) => {
                            const reviewText = getReviewText(review);
                            const truncatedReview =
                              reviewText.split(" ").slice(0, 12).join(" ") +
                              (reviewText.split(" ").length > 12 ? "..." : "");

                            const rating = review?.rating || 0;
                            const formattedDate = getFormattedDate(review);

                            return (
                              <div
                                key={review.review_id || idx}
                                onClick={() => handleReviewSelect(idx)}
                                className={`p-4 border rounded-xl relative bg-white cursor-pointer transition
        ${
          selectedReviews.includes(idx)
            ? "border-blue-500 ring-2 ring-blue-200"
            : ""
        }
    `}
                              >
                                <div className="flex justify-between mb-2">
                                  <span className="text-gray-700 font-medium">
                                    {getAuthorName(review)}
                                  </span>
                                  <input
                                    type="checkbox"
                                    checked={selectedReviews.includes(idx)}
                                    onChange={() => handleReviewSelect(idx)}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </div>

                                <span className="text-yellow-500 text-lg block">
                                  {"★".repeat(rating)}
                                  {"☆".repeat(5 - rating)}
                                </span>

                                <p className="pb-4 text-gray-500">
                                  {truncatedReview}
                                </p>

                                <p className="text-gray-600 font-semibold text-sm absolute bottom-2">
                                  {formattedDate}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      )}

                      {/* 🚫 NO REVIEWS */}
                      {!reviewsLoading && reviews.length === 0 && (
                        <p className="text-center text-gray-500 py-10">
                          Keine negativen Bewertungen gefunden
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {currentStep === 3 && (
                  <section className="flex flex-col gap-6 w-full font-san-francisco">
                    <hr className="bg-custom-gray-240 border-0 h-[1px] w-full" />

                    <form
                      id="customer-form"
                      onSubmit={handleSubmit}
                      className="flex flex-col lg:gap-[28px] gap-[14px]"
                    >
                      {/* Kundeninformationen */}
                      <div className="flex justify-between lg:flex-row flex-col lg:items-center gap-2">
                        <h3 className="lg:text-[24px] text-[20px] lg:leading-[120%] text-black font-semibold">
                          Kundeninformationen
                        </h3>
                      </div>

                      <div className="flex flex-col lg:gap-[10px] gap-[14px]">
                        <div className="flex lg:flex-row flex-col lg:gap-[10px] gap-[14px]">
                          {/* Salutation */}
                          <div className="w-full relative">
                            <select
                              aria-invalid="false"
                              name="salutation"
                              required
                              value={formData.salutation}
                              onChange={handleChange}
                              className="text-[#9ca3af] focus-visible:border-black focus-visible:shadow-[inset_0_0_0_1px_black] appearance-none remove-arrow w-full outline-none border bg-white cursor-pointer font-san-francisco py-[14px] px-5 text-base font-regular rounded-[10px] border-black/20 h-[52px]"
                            >
                              <option hidden value="">
                                Anrede
                              </option>
                              <option value="herr">Herr</option>
                              <option value="frau">Frau</option>
                            </select>
                          </div>

                          {/* First Name */}
                          <div className="w-full relative z-0">
                            <input
                              type="text"
                              name="firstName"
                              placeholder="Vorname"
                              value={formData.firstName}
                              onChange={handleChange}
                              className="font-san-francisco text-base text-black/60 font-regular px-5 py-[14px] border rounded-[10px] border-black/20 w-full h-[52px]"
                            />
                          </div>

                          {/* Last Name */}
                          <div className="w-full relative z-0">
                            <input
                              type="text"
                              name="surname"
                              placeholder="Nachname"
                              value={formData.surname}
                              onChange={handleChange}
                              className="font-san-francisco text-base text-black/60 font-regular px-5 py-[14px] border rounded-[10px] border-black/20 w-full h-[52px]"
                            />
                          </div>
                        </div>

                        {/* Email and Phone */}
                        <div className="flex flex-col lg:gap-[10px] gap-[14px]">
                          <div className="w-full relative z-0">
                            <input
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              placeholder="E-Mail"
                              className="font-san-francisco text-base text-black/60 font-regular px-5 py-[14px] border rounded-[10px] border-black/20 w-full h-[52px]"
                            />
                          </div>
                          <div className="w-full relative z-0">
                            <input
                              type="text"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              placeholder="Telefon (für Rückfragen)"
                              className="font-san-francisco text-base text-black/60 font-regular px-5 py-[14px] border rounded-[10px] border-black/20 w-full h-[52px]"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Zahlungsdetails */}
                      <div className="flex flex-col lg:gap-[28px] gap-[24px]">
                        <div className="flex justify-between lg:flex-row flex-col lg:items-center gap-2">
                          <h3 className="lg:text-[24px] text-[20px] lg:leading-[120%] text-black font-semibold">
                            Zahlungsdetails
                          </h3>
                        </div>

                        <div className="flex flex-col lg:gap-[10px] gap-[14px]">
                          <div className="flex lg:flex-row flex-col lg:gap-[10px] gap-[14px]">
                            <div className="w-full relative z-0">
                              <input
                                type="text"
                                name="firma"
                                value={formData.firma}
                                onChange={handleChange}
                                placeholder="Firma"
                                className="font-san-francisco text-base text-black/60 font-regular px-5 py-[14px] border rounded-[10px] border-black/20 w-full h-[52px]"
                              />
                            </div>
                            <div className="w-full relative z-0">
                              <input
                                type="text"
                                name="street"
                                placeholder="Straße, Hausnummer"
                                value={formData.street}
                                onChange={handleChange}
                                className="font-san-francisco text-base text-black/60 font-regular px-5 py-[14px] border rounded-[10px] border-black/20 w-full h-[52px]"
                              />
                            </div>
                          </div>

                          <div className="flex lg:flex-row flex-col lg:gap-[10px] gap-[14px]">
                            <div className="w-full relative z-0">
                              <input
                                type="text"
                                name="plz"
                                placeholder="PLZ"
                                value={formData.plz}
                                onChange={handleChange}
                                className="font-san-francisco text-base text-black/60 font-regular px-5 py-[14px] border rounded-[10px] border-black/20 w-full h-[52px]"
                              />
                            </div>
                            <div className="w-full relative z-0">
                              <input
                                type="text"
                                name="location"
                                value={formData.location}
                                onChange={handleChange}
                                placeholder="Ort"
                                className="font-san-francisco text-base text-black/60 font-regular px-5 py-[14px] border rounded-[10px] border-black/20 w-full h-[52px]"
                              />
                            </div>
                          </div>
                        </div>
                        <button
                          type="submit"
                          form="customer-form"
                          onClick={() => setMobileSidebarOpen(false)} // optional, but nice UX
                          className="w-full py-3 font-semibold rounded-full transition flex gap-8 items-center justify-between px-4 bg-[#0b2b40] hover:opacity-90 text-white"
                        >
                          Absenden
                          <span className="bg-white text-gray-900 p-1 rounded-full flex items-center justify-center">
                            <HiArrowRight className="text-lg transform -rotate-24" />
                          </span>
                        </button>
                        <div className="text-justify">
                          <div className=" text-xs leading-[133%] text-custom-purple-300 mt-2.5">
                            <span className="text-sm font-bold text-gray-400">
                              Bezahlung nur im Erfolgsfall – Ihre Sicherheit hat
                              für uns höchste Priorität
                            </span>{" "}
                            <br />
                            <span className="text-sm text-gray-400">
                              Vertrauen ist die Grundlage jeder guten
                              Zusammenarbeit. Deshalb haben wir unser
                              Abrechnungsmodell bewusst transparent, fair und
                              vollkommen risikofrei für Sie gestaltet.
                            </span>
                            <div className="font-bold mt-2 mb-2 text-gray-600">
                              So funktioniert unser Erfolgsprinzip:{" "}
                            </div>
                            <div className="pl-4 space-y-2">
                              <div className="flex gap-2 mt-1">
                                <div className="font-bold text-gray-600">
                                  1.
                                </div>
                                <div>
                                  <span className="font-bold text-gray-600">
                                    {" "}
                                    Beauftragung{" "}
                                  </span>
                                  <span className="text-sm text-gray-400">
                                    Nach Ihrer Beauftragung erfolgt die Meldung
                                    der betreffenden Bewertung(en) durch Sie
                                    beim jeweiligen Plattformbetreiber.
                                  </span>
                                </div>
                              </div>

                              <div className="flex gap-2 mt-1">
                                <div className="font-bold text-gray-600">
                                  2.
                                </div>
                                <div>
                                  <span className="font-bold text-gray-600">
                                    Keine Vorauszahlung{" "}
                                  </span>
                                  <span className="text-sm text-gray-400">
                                    Sie gehen keinerlei finanzielles Risiko ein:
                                    Es ist keine Vorauszahlung erforderlich.
                                  </span>
                                </div>
                              </div>

                              <div className="flex gap-2 mt-1">
                                <div className="font-bold text-gray-600">
                                  3.
                                </div>
                                <div>
                                  <span className="font-bold text-gray-600">
                                    Transparente Erfolgskontrolle{" "}
                                  </span>
                                  <span className="text-sm text-gray-400">
                                    Während des gesamten Prozesses halten wir
                                    Sie über alle Fortschritte auf dem
                                    Laufenden. Sobald der Prozess abgeschlossen
                                    ist, erhalten Sie eine übersichtliche
                                    Dokumentation der erzielten Ergebnisse.
                                  </span>
                                </div>
                              </div>

                              <div className="flex gap-2 mt-1">
                                <div className="font-bold text-gray-600">
                                  4.
                                </div>
                                <div>
                                  <span className="font-bold text-gray-600">
                                    Zahlung ausschließlich nach Erfolg{" "}
                                  </span>
                                  <span className="text-sm text-gray-400">
                                    {" "}
                                    Eine Abrechnung erfolgt nur für tatsächlich
                                    entfernte Bewertungen durch den
                                    Plattformbetreiber. Sollten keine Erfolge
                                    erzielt werden, entstehen Ihnen
                                    selbstverständlich keinerlei Kosten.
                                  </span>
                                </div>
                              </div>
                            </div>
                            <p className="font-bold text-gray-600 mt-4 mb-1">
                              Haben Sie Fragen?{" "}
                            </p>
                            <span className="text-sm text-gray-400">
                              Bei Fragen oder Informationsbedarf können Sie uns
                              jederzeit kontaktieren.
                            </span>
                          </div>
                        </div>
                      </div>
                    </form>
                  </section>
                )}
              </div>

              {/* RIGHT FIXED SECTION */}
              {(currentStep === 2 || currentStep === 3) && (
                <div className="hidden md:flex fixed top-0 right-0 h-screen w-[28%] bg-gray-100 flex-col">
                  {/* Scrollable content */}
                  <div className="h-[calc(100vh-220px)] overflow-y-auto overflow-hidden p-5 flex flex-col gap-4">
                    {/* Coupon Code & Price */}
                    <div className="border rounded bg-white p-5">
                      <div className="flex gap-0">
                        <input
                          type="text"
                          placeholder="Gutschein eingeben"
                          className="flex-1 border rounded-l-xl px-4 py-2 outline-none"
                        />
                        <button className="bg-[#0b2b40] text-white rounded-r-xl px-4">
                          einlösen
                        </button>
                      </div>
                      {activeTier < 2 && reviewsLeftForNextTier >= 0 && (
                        <p className="text-sm text-gray-500 mt-1">
                          Nur noch {reviewsLeftForNextTier}{" "}
                          <strong>Bewertungen</strong>
                          {reviewsLeftForNextTier !== 1 && "s"} für die
                          günstigere Preisstaffelung
                        </p>
                      )}
                      {/* Progress Bar */}
                      <div className="mt-4">
                        {/* <div className="flex justify-between text-xs text-gray-500 mb-1">
                                            <span>Auswahl Fortschritt</span>
                                            <span>{selectedCount} Reviews</span>
                                        </div> */}

                        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                          <div
                            className="h-full bg-[#0b2b40] transition-all duration-500 ease-out"
                            style={{ width: `${getProgressPercentage()}%` }}
                          />
                        </div>

                        {/* <div className="flex justify-between text-[11px] text-gray-400 mt-1">
                                            <span>
                                                {activeTier === 0 && "0 / 5"}
                                                {activeTier === 1 && "6 / 10"}
                                                {activeTier === 2 && "10+"}
                                            </span>
                                            <span>
                                                {activeTier === 0 && "Bis zu 5"}
                                                {activeTier === 1 && "Ab 6"}
                                                {activeTier === 2 && "Maximal"}
                                            </span>
                                        </div> */}
                      </div>

                      {activeTier < 2 && saveAmount > 0 && (
                        <p className="text-sm text-bold mt-1 text-gray-500 italic">
                          Sparen Sie €{saveAmount} bei der nächsten Stufe
                        </p>
                      )}

                      <div className="grid grid-cols-2 gap-2 mt-2">
                        {[0, 1, 2].map((tier) => (
                          <div
                            key={tier}
                            className={`border py-3 px-1 pl-2 rounded-xl text-left cursor-pointer ${
                              activeTier === tier
                                ? "bg-[#3c6e711a] text-gray-800 border-1 border-[#3c6e71]"
                                : "bg-white"
                            }`}
                          >
                            <p className="text-sm text-gray-600">
                              {tier === 0
                                ? "Bis zu 5 Löschungen"
                                : tier === 1
                                ? "Ab 6 Löschungen"
                                : "Ab 10 Löschungen"}
                            </p>
                            <p className="text-sm font-semibold text-gray-800">
                              €{tier === 0 ? 129 : tier === 1 ? 89 : 79},00
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Company Info */}
                    <div className="border p-3 rounded-xl bg-gray-50 flex flex-col gap-2 mt-2">
                      <span className="text-sm text-gray-400">
                        Im Falle einer erfolgreichen Löschung der von Ihnen
                        gemeldeten Bewertungen könnte Ihre Google-Bewertung das
                        folgende Rating aufweisen:
                      </span>
                      <img
                        src={business?.photoUrl}
                        alt="Company"
                        className="w-full h-24 object-cover rounded-md"
                      />
                      <p className="font-semibold">{business?.name?.text}</p>
                      <p>
                        Potenzielle Verbesserung auf:{" "}
                        <span className="font-bold">
                          {calculateNewRating()} ★
                        </span>
                      </p>
                      <p className="text-sm text-gray-500">
                        ({selectedReviews.length} selected)
                      </p>
                    </div>
                    <div className="max-w-sm mx-auto">
                      <div className="relative rounded-3xl border border-green-400 bg-gradient-to-br from-green-100 via-green-50 to-white shadow-2xl overflow-hidden transform hover:scale-105 transition-transform duration-500">
                        {/* BEST OPTION BADGE */}
                        <div className="absolute top-0 left-0">
                          <div className="bg-green-500 text-white text-xs font-bold px-4 py-1 rounded-br-2xl flex items-center gap-1 shadow-md">
                            ✓ BESTE OPTION
                          </div>
                        </div>

                        {/* CONTENT */}
                        <div className="p-6 pt-12 text-center relative z-10">
                          {/* TITLE */}
                          {activeTier === 0 && (
                            <p className="text-gray-800 text-lg font-semibold">
                              Ab{" "}
                              <span className="font-boldtext-[#8ec700]">
                                6 Löschungen
                              </span>
                            </p>
                          )}
                          {activeTier === 1 && (
                            <p className="text-gray-800 text-lg font-semibold">
                              Ab{" "}
                              <span className="font-boldtext-[#8ec700]">
                                10 Löschungen
                              </span>
                            </p>
                          )}

                          {/* PRICE */}
                          {activeTier === 0 && (
                            <div className="text-5xl font-extrabold text-gray-900 my-4">
                              € 89
                            </div>
                          )}
                          {activeTier === 1 && (
                            <div className="text-5xl font-extrabold text-gray-900 my-4">
                              € 79
                            </div>
                          )}

                          {/* DISCOUNT */}
                          {activeTier === 0 && (
                            <div className="inline-flex items-center gap-3 bg-green-400 text-white text-sm px-4 py-2 rounded-full mb-4 shadow-sm">
                              <span className="relative font-bold text-lg text-white">
                                € 129
                                <span className="absolute left-0 top-1/2 w-full h-[1px] bg-black transform -translate-y-1/2"></span>
                              </span>
                              <span className="font-semibold text-base">
                                € 89
                              </span>
                              <span className="font-bold ml-1">Sie sparen</span>
                              <span className="bg-green-200 text-green-800 text-xs font-semibold px-2 py-0.5 rounded-full">
                                –31%
                              </span>
                            </div>
                          )}

                          {activeTier === 1 && (
                            <div className="inline-flex items-center gap-3 bg-green-400 text-white text-sm px-4 py-2 rounded-full mb-4 shadow-md">
                              <span className="relative font-bold text-lg text-white">
                                € 89
                                <span className="absolute left-0 top-1/2 w-full h-[1px] bg-black transform -translate-y-1/2"></span>
                              </span>
                              <span className="font-semibold text-base">
                                € 79
                              </span>
                              <span className="font-bold ml-1">Sie sparen</span>
                              <span className="bg-black text-white text-sm font-semibold px-2 py-0.5 rounded-full">
                                –39%
                              </span>
                            </div>
                          )}

                          {/* WARNING */}
                          <div className="flex items-center justify-center gap-2 text-sm text-gray-700 border-t border-dashed pt-4 mt-4">
                            <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-green-500 text-white text-xs font-bold">
                              !
                            </div>
                            {activeTier < 2 && reviewsLeftForNextTier >= 0 && (
                              <p className="text-gray-600 leading-tight">
                                Nur noch{" "}
                                <strong>
                                  {reviewsLeftForNextTier} Bewertung
                                </strong>
                                {reviewsLeftForNextTier !== 1 && "en"} für die
                                günstigere Preisstaffelung
                              </p>
                            )}
                          </div>

                          {/* PRICE + RATING */}
                          <div className="mt-6">
                            <p className="text-xl font-semibold text-gray-900">
                              €{pricePerDeletion.toFixed(2)}{" "}
                              <span className="text-yellow-400">→ ★★★★★</span>
                            </p>
                            <p className="text-sm text-gray-500 mt-1">
                              Gesamtbetrag:{" "}
                              <span className="font-semibold text-gray-700">
                                €
                                {(
                                  selectedReviews.length * pricePerDeletion
                                ).toFixed(2)}
                              </span>
                            </p>
                          </div>

                          {/* FEATURES */}
                          <div className="mt-6 space-y-3 text-left text-sm text-gray-700">
                            <div className="flex items-center gap-2">
                              <span className="text-green-500">✔</span>
                              Zahlung nur bei erfolgreicher Löschung
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="text-green-500">✔</span>
                              Keine Vorauszahlung
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="text-green-500">✔</span>
                              DSGVO-konform
                            </div>
                          </div>

                          {/* BUTTON */}
                          {/* <button className="w-full mt-6 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold py-3 rounded-xl shadow-lg hover:scale-105 transition transform duration-300">
                                                Bewertungen jetzt entfernen lassen
                                            </button> */}
                        </div>

                        {/* Background Overlay for Depth */}
                        <div className="absolute inset-0 bg-gradient-to-t from-green-50 via-white to-transparent opacity-30 pointer-events-none rounded-3xl"></div>
                      </div>
                    </div>
                  </div>

                  {/* Fixed bottom section */}
                  <div className="absolute bottom-0 left-0 right-0 p-5 bg-gray-100 border-t">
                    <div className="border p-3 rounded-xl bg-gray-100">
                      <div className="flex justify-between align-center">
                        {" "}
                        <p className="text-lg text-gray-600 font-bold">
                          Preis pro Löschung
                        </p>
                        <h2 className="text-[#0b2b40] text-2xl font-bold">
                          €{pricePerDeletion.toFixed(2)}
                        </h2>{" "}
                      </div>
                      <div className="flex justify-between align-center">
                        <p className="text-sm font-bold">Gesamtsumme </p>
                        <p className="text-sm text-gray-600">
                          €
                          {(selectedReviews.length * pricePerDeletion).toFixed(
                            2
                          )}
                        </p>
                      </div>
                    </div>
                    {currentStep === 2 && (
                      <button
                        onClick={nextStep}
                        disabled={selectedReviews.length === 0}
                        className={`w-full py-3 font-semibold rounded-full transition flex gap-8 items-center justify-between px-4
        ${
          selectedReviews.length === 0
            ? "bg-[#0b2b40] bg-opacity-40 cursor-not-allowed"
            : "bg-[#0b2b40] hover:opacity-90 text-white"
        }
    `}
                      >
                        {" "}
                        Jetzt risikofrei starten
                        <span className="bg-white text-gray-900 p-1 rounded-full flex items-center justify-center">
                          <HiArrowRight className="text-lg transform -rotate-24" />
                        </span>
                      </button>
                    )}
                    {currentStep === 3 && (
                      <button
                        type="submit"
                        form="customer-form"
                        className={`w-full py-3 font-semibold rounded-full transition flex gap-8 items-center justify-between px-4 bg-[#0b2b40] hover:opacity-90 text-white`}
                      >
                        {" "}
                        Absenden
                        <span className="bg-white text-gray-900 p-1 rounded-full flex items-center justify-center">
                          <HiArrowRight className="text-lg transform -rotate-24" />
                        </span>
                      </button>
                    )}

                    <div className="text-center flex align-center justify-center">
                      <p className="text-xs text-gray-500 mt-1 w-[70%] text-center align-centet flex justify-center ">
                        Kosten entstehen lediglich für Bewertungen, deren
                        Entfernung erfolgreich war.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* <button onClick={handleProceed} className="bg-[#0b2b40] hover:opacity-90 text-white rounded-full px-8 py-3 text-lg font-medium mx-auto">
                            Weiter
                        </button> */}
          </div>
        </div>
        {/* MOBILE SLIDE-IN SIDEBAR */}
        <div
          className={`fixed inset-0 z-50 md:hidden transition-all duration-300 ${
            mobileSidebarOpen ? "pointer-events-auto" : "pointer-events-none"
          }`}
        >
          {/* Backdrop */}
          <div
            className={`absolute inset-0 bg-black/40 transition-opacity duration-300 ${
              mobileSidebarOpen ? "opacity-100" : "opacity-0"
            }`}
            onClick={() => setMobileSidebarOpen(false)}
          />

          {/* Sidebar panel */}
          <div
            className={`absolute top-0 right-0 h-full w-[90%] max-w-sm bg-gray-100 shadow-xl
    transform transition-transform duration-300 ease-in-out
    ${mobileSidebarOpen ? "translate-x-0" : "translate-x-full"}`}
          >
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b bg-white">
              <h3 className="text-lg font-semibold">Warenkorb</h3>
              <button
                onClick={() => setMobileSidebarOpen(false)}
                className="text-gray-600 text-xl"
              >
                ✕
              </button>
            </div>

            {/* Scrollable content */}
            <div className="h-[calc(100%-70px)] overflow-y-auto p-4 flex flex-col gap-4">
              {/* ⬇️ COPY CONTENT FROM DESKTOP SIDEBAR HERE ⬇️ */}

              <div className="block md:hidden fixed h-[100vh] top-0 left-0 w-[100%]  bg-gray-100 rounded flex flex-col">
                {/* Scrollable content */}
                <div className="flex-1 overflow-y-auto p-5 scrollbar-hide flex flex-col gap-4">
                  {/* Coupon Code & Price */}
                  <div className="border rounded bg-white p-5">
                    <div className="flex gap-0">
                      <input
                        type="text"
                        placeholder="Gutschein eingeben"
                        className="flex-1 border rounded-l-xl px-4 py-2 outline-none"
                      />
                      <button className="bg-[#0b2b40] ml-[-60px] text-white rounded-r-xl px-4 py-2">
                        einlösen
                      </button>
                    </div>
                    {activeTier < 2 && reviewsLeftForNextTier > 0 && (
                      <p className="text-sm text-gray-500 mt-1">
                        Nur noch {reviewsLeftForNextTier}{" "}
                        <strong>Bewertungen</strong>
                        {reviewsLeftForNextTier !== 1 && "s"} für die günstigere
                        Preisstaffelung
                      </p>
                    )}
                    {/* Progress Bar */}
                    <div className="mt-4">
                      {/* <div className="flex justify-between text-xs text-gray-500 mb-1">
                                            <span>Auswahl Fortschritt</span>
                                            <span>{selectedCount} Reviews</span>
                                        </div> */}

                      <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-[#0b2b40] transition-all duration-500 ease-out"
                          style={{ width: `${getProgressPercentage()}%` }}
                        />
                      </div>

                      {/* <div className="flex justify-between text-[11px] text-gray-400 mt-1">
                                            <span>
                                                {activeTier === 0 && "0 / 5"}
                                                {activeTier === 1 && "6 / 10"}
                                                {activeTier === 2 && "10+"}
                                            </span>
                                            <span>
                                                {activeTier === 0 && "Bis zu 5"}
                                                {activeTier === 1 && "Ab 6"}
                                                {activeTier === 2 && "Maximal"}
                                            </span>
                                        </div> */}
                    </div>

                    {activeTier < 2 && saveAmount > 0 && (
                      <p className="text-sm text-bold mt-1 text-gray-500 italic">
                        Sparen Sie €{saveAmount} bei der nächsten Stufe
                      </p>
                    )}

                    <div className="grid grid-cols-2 gap-2 mt-2">
                      {[0, 1, 2].map((tier) => (
                        <div
                          key={tier}
                          className={`border py-3 px-1 pl-2 rounded-xl text-left cursor-pointer ${
                            activeTier === tier
                              ? "bg-[#3c6e711a] text-gray-800 border-1 border-[#3c6e71]"
                              : "bg-white"
                          }`}
                        >
                          <p className="text-sm text-gray-600">
                            {tier === 0
                              ? "Bis zu 5 Löschungen"
                              : tier === 1
                              ? "Ab 6 Löschungen"
                              : "Ab 10 Löschungen"}
                          </p>
                          <p className="text-sm font-semibold text-gray-800">
                            €{tier === 0 ? 129 : tier === 1 ? 89 : 79},00
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Company Info */}
                  <div className="border p-3 rounded-xl bg-gray-50 flex flex-col gap-2 mt-2">
                    <span className="text-sm text-gray-400">
                      Im Falle einer erfolgreichen Löschung der von Ihnen
                      gemeldeten Bewertungen könnte Ihre Google-Bewertung das
                      folgende Rating aufweisen:
                    </span>
                    <img
                      src={business?.photoUrl}
                      alt="Company"
                      className="w-full h-24 object-cover rounded-md"
                    />
                    <p className="font-semibold">{business?.name?.text}</p>
                    <p>
                      Potenzielle Verbesserung auf:{" "}
                      <span className="font-bold">
                        {calculateNewRating()} ★
                      </span>
                    </p>
                    <p className="text-sm text-gray-500">
                      ({selectedReviews.length} selected)
                    </p>
                  </div>
                  <div className="max-w-sm mx-auto">
                    <div className="relative rounded-3xl border border-green-400 bg-gradient-to-br from-green-100 via-green-50 to-white shadow-2xl overflow-hidden transform hover:scale-105 transition-transform duration-500">
                      {/* BEST OPTION BADGE */}
                      <div className="absolute top-0 left-0">
                        <div className="bg-green-500 text-white text-xs font-bold px-4 py-1 rounded-br-2xl flex items-center gap-1 shadow-md">
                          ✓ BESTE OPTION
                        </div>
                      </div>

                      {/* CONTENT */}
                      <div className="p-6 pt-12 text-center relative z-10">
                        {/* TITLE */}
                        {activeTier === 0 && (
                          <p className="text-gray-800 text-lg font-semibold">
                            Ab{" "}
                            <span className="font-boldtext-[#8ec700]">
                              6 Löschungen
                            </span>
                          </p>
                        )}
                        {activeTier === 1 && (
                          <p className="text-gray-800 text-lg font-semibold">
                            Ab{" "}
                            <span className="font-boldtext-[#8ec700]">
                              10 Löschungen
                            </span>
                          </p>
                        )}

                        {/* PRICE */}
                        {activeTier === 0 && (
                          <div className="text-5xl font-extrabold text-gray-900 my-4">
                            € 89
                          </div>
                        )}
                        {activeTier === 1 && (
                          <div className="text-5xl font-extrabold text-gray-900 my-4">
                            € 79
                          </div>
                        )}

                        {/* DISCOUNT */}
                        {activeTier === 0 && (
                          <div className="inline-flex items-center gap-3 bg-green-400 text-white text-sm px-4 py-2 rounded-full mb-4 shadow-sm">
                            <span className="relative font-bold text-lg text-white">
                              € 129
                              <span className="absolute left-0 top-1/2 w-full h-[1px] bg-black transform -translate-y-1/2"></span>
                            </span>
                            <span className="font-semibold text-base">
                              € 89
                            </span>
                            <span className="font-bold ml-1">Sie sparen</span>
                            <span className="bg-green-200 text-green-800 text-xs font-semibold px-2 py-0.5 rounded-full">
                              –31%
                            </span>
                          </div>
                        )}

                        {activeTier === 1 && (
                          <div className="inline-flex items-center gap-3 bg-green-400 text-white text-sm px-2 py-2 rounded-full mb-4 shadow-md">
                            <span className="relative font-bold text-lg text-white">
                              € 89
                              <span className="absolute left-0 top-1/2 w-full h-[1px] bg-black transform -translate-y-1/2"></span>
                            </span>
                            <span className="font-semibold text-base">
                              € 79
                            </span>
                            <span className="font-bold ml-1">Sie sparen</span>
                            <span className="bg-black text-white text-sm font-semibold px-2 py-0.5 rounded-full">
                              –39%
                            </span>
                          </div>
                        )}

                        {/* WARNING */}
                        <div className="flex items-center justify-center gap-2 text-sm text-gray-700 border-t border-dashed pt-4 mt-4">
                          <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-green-500 text-white text-xs font-bold">
                            !
                          </div>
                          {activeTier < 2 && reviewsLeftForNextTier >= 0 && (
                            <p className="text-gray-600 leading-tight">
                              Nur noch{" "}
                              <strong>
                                {reviewsLeftForNextTier} Bewertung
                              </strong>
                              {reviewsLeftForNextTier !== 1 && "en"} für die
                              günstigere Preisstaffelung
                            </p>
                          )}
                        </div>

                        {/* PRICE + RATING */}
                        <div className="mt-6">
                          <p className="text-xl font-semibold text-gray-900">
                            €{pricePerDeletion.toFixed(2)}{" "}
                            <span className="text-yellow-400">→ ★★★★★</span>
                          </p>
                          <p className="text-sm text-gray-500 mt-1">
                            Gesamtbetrag:{" "}
                            <span className="font-semibold text-gray-700">
                              €
                              {(
                                selectedReviews.length * pricePerDeletion
                              ).toFixed(2)}
                            </span>
                          </p>
                        </div>

                        {/* FEATURES */}
                        <div className="mt-6 space-y-3 text-left text-sm text-gray-700">
                          <div className="flex items-center gap-2">
                            <span className="text-green-500">✔</span>
                            Zahlung nur bei erfolgreicher Löschung
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="text-green-500">✔</span>
                            Keine Vorauszahlung
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="text-green-500">✔</span>
                            DSGVO-konform
                          </div>
                        </div>

                        {/* BUTTON */}
                        {/* <button className="w-full mt-6 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold py-3 rounded-xl shadow-lg hover:scale-105 transition transform duration-300">
                                                Bewertungen jetzt entfernen lassen
                                            </button> */}
                      </div>

                      {/* Background Overlay for Depth */}
                      <div className="absolute inset-0 bg-gradient-to-t from-green-50 via-white to-transparent opacity-30 pointer-events-none rounded-3xl"></div>
                    </div>
                  </div>
                </div>

                {/* Fixed bottom section */}
                <div className="border-t  p-5 bg-gray-100 flex flex-col gap-2 sticky bottom-0">
                  <div className="border p-3 rounded-xl bg-gray-100">
                    <div className="flex justify-between align-center">
                      {" "}
                      <p className="text-lg font-bold ">Preis pro Löschung</p>
                      <p className="text-lg font-bold">
                        €{pricePerDeletion.toFixed(2)}
                      </p>{" "}
                    </div>
                    <div className="flex justify-between align-center mt-2">
                      <p className="text-sm text-gray-600">Gesamtsumme </p>
                      <h2 className="text-[#0b2b40] text-sm font-bold">
                        €
                        {(selectedReviews.length * pricePerDeletion).toFixed(2)}
                      </h2>
                    </div>
                  </div>

                  <button
                    onClick={nextStep}
                    disabled={selectedReviews.length === 0}
                    className={`w-full py-3 font-semibold rounded-full transition flex gap-8 items-center justify-between px-4
        ${
          selectedReviews.length === 0
            ? "bg-[#0b2b40] bg-opacity-40 cursor-not-allowed"
            : "bg-[#0b2b40] hover:opacity-90 text-white"
        }
    `}
                  >
                    {" "}
                    Jetzt risikofrei buchen
                    <span className="bg-white text-gray-900 p-1 rounded-full flex items-center justify-center">
                      <HiArrowRight className="text-lg transform -rotate-24" />
                    </span>
                  </button>
                  <div className="text-center flex align-center justify-center">
                    <p className="text-xs text-gray-500 mt-1 w-[70%] text-center align-centet flex justify-center ">
                      Kosten entstehen lediglich für Bewertungen, deren
                      Entfernung erfolgreich war.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {selectedCount > 0 && currentStep === 2 && (
          <div className="fixed border shadow-lg bottom-0 inset-x-0 bg-white md:hidden">
            <div className="px-4 py-8">
              <div className="flex mb-4 justify-between align-center">
                <p className="text-lg font-bold">Preis pro Löschung </p>
                <h2 className="text-[#0b2b40] text-2xl font-bold">
                  €{pricePerDeletion.toFixed(2)}
                </h2>
              </div>
              <button
                onClick={() => setMobileSidebarOpen(true)}
                className="w-full py-3 bg-[#0b2b40] text-white rounded-full flex justify-center items-center gap-3"
              >
                <span class="px-3 w-full flex gap-[12px] justify-center items-center">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M8 22C8.55228 22 9 21.5523 9 21C9 20.4477 8.55228 20 8 20C7.44772 20 7 20.4477 7 21C7 21.5523 7.44772 22 8 22Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M19 22C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20C18.4477 20 18 20.4477 18 21C18 21.5523 18.4477 22 19 22Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M2.05078 2.05005H4.05078L6.71078 14.47C6.80836 14.9249 7.06145 15.3315 7.42649 15.6199C7.79153 15.9083 8.24569 16.0604 8.71078 16.05H18.4908C18.946 16.0493 19.3873 15.8933 19.7418 15.6079C20.0964 15.3224 20.3429 14.9246 20.4408 14.48L22.0908 7.05005H5.12078"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                  Warenkorb öffnen
                </span>
              </button>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

const StepCircle = ({ number, text, active }) => (
  <div className="flex flex-col items-center gap-3 min-w-[90px] text-center">
    <div
      className={`w-[60px] h-[60px] flex items-center justify-center rounded-full text-white text-[24px] font-semibold ${
        active ? "bg-[#0b2b40]" : "bg-[#0b2b40]/30"
      }`}
    >
      {number}
    </div>
    <p
      className={`text-[16px] font-medium ${
        active ? "text-[#0b2b40]" : "text-[#0b2b40]/40"
      }`}
    >
      {text}
    </p>
  </div>
);

const StepLine = ({ active, mobile }) => (
  <div
    className={`rounded-full ${
      mobile ? "w-[35px] h-[4px]" : "w-[130px] h-[4px]"
    } ${
      active
        ? "bg-gradient-to-r from-[#0b2b40] to-white"
        : "bg-gradient-to-r from-[#0b2b40]/30 to-white/30"
    }`}
  ></div>
);

export default HowRemoveStep2;
